import { initialState } from '../store.settings'

export const clrSettings = (state) => {
  state = initialState
  return state
}
